import { DependsOnIfEnum } from "@generation/schema-core/src/client/enums/dependsOnIfEnum";
import { DependsOnThenEnum } from "@generation/schema-core/src/client/enums/dependsOnThenEnum";
import { IDependsOn } from "@generation/schema-core/src/client/model/dependsOn";
import { SelectFieldOrderBy } from "@generation/schema-core/src/client/model/options/selectFieldOrderByEnum";
import { GetAdresFieldSet } from "@klantondersteuning/shared";
import { ISimpleForm } from "@klantondersteuning/shared/src/form/interface/SimpleForm/ISimpleForm";
import { PredefinedFieldType } from "@klantondersteuning/shared/src/form/interface/SimpleForm/PredefinedFieldType";
import { RegelingOptions } from "@klantondersteuning/shared/src/form/interface/SimpleForm/RegelingOptions";
import { translate } from "@opencak-klantondersteuning/shared";

const regelingProperty = "stap_mijn_client__mijn_client.regeling";
const dependsOnShowIfWmoOrBwOrWlz: IDependsOn[] = [
  {
    property: regelingProperty,
    value: RegelingOptions.Buitenland,
    if: DependsOnIfEnum.IsEqualToValue,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  },
  {
    property: regelingProperty,
    value: RegelingOptions.BetalingsachterstandZorgpremie,
    if: DependsOnIfEnum.IsEqualToValue,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  },
  {
    property: regelingProperty,
    value: RegelingOptions.Onverzekerden,
    if: DependsOnIfEnum.IsEqualToValue,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  },
  {
    property: regelingProperty,
    if: DependsOnIfEnum.IsNotGiven,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  }
];

const dependsOnShowIfBurgerregeling: IDependsOn[] = [
  {
    property: regelingProperty,
    value: RegelingOptions.WmoAT,
    if: DependsOnIfEnum.IsEqualToValue,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  },
  {
    property: regelingProperty,
    value: RegelingOptions.Wlz,
    if: DependsOnIfEnum.IsEqualToValue,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  },
  {
    property: regelingProperty,
    value: RegelingOptions.BeschermdWonen,
    if: DependsOnIfEnum.IsEqualToValue,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  },
  {
    property: regelingProperty,
    if: DependsOnIfEnum.IsNotGiven,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  }
];

const dependsOnShowIfRegelingIsGiven: IDependsOn[] = [
  {
    property: regelingProperty,
    if: DependsOnIfEnum.IsNotGiven,
    isAbsolutePath: true,
    then: DependsOnThenEnum.Hide
  }
];
export const GetBewindvoerdersCuratorenClientAanmeldenFormulier = (): ISimpleForm => {
  return {
    name: "bewindvoerders-curatoren-client-aanmelden-formulier",
    steps: [
      {
        name: translate("BewindvoerdersCuratorenClientAanmeldenFormulierStapInleiding"),
        isIntroduction: true
      },
      {
        name: translate("BewindvoerdersCuratorenClientAanmeldenFormulierMijnClient"),
        Sections: [
          {
            name: "stap_mijn_client__mijn_client",
            fields: {
              regeling: {
                predefinedFieldType: PredefinedFieldType.regeling,
                isRequired: true,
                regelingOptions: [
                  RegelingOptions.Wlz,
                  RegelingOptions.WmoAT,
                  RegelingOptions.BeschermdWonen,
                  RegelingOptions.Buitenland,
                  RegelingOptions.BetalingsachterstandZorgpremie,
                  RegelingOptions.Onverzekerden
                ],
                orderOptionsBy: {
                  orderBy: SelectFieldOrderBy.Alphabetical,
                  exclusions: [RegelingOptions.Onbekend]
                }
              },
              voorletters: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true,
                dependsOn: dependsOnShowIfRegelingIsGiven
              },
              achternaam: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true,
                autoComplete: true,
                dependsOn: dependsOnShowIfRegelingIsGiven
              },
              geboortedatum: {
                isRequired: true,
                predefinedFieldType: PredefinedFieldType.geboortedatum,
                dependsOn: dependsOnShowIfRegelingIsGiven
              },
              burgerservicenummer: {
                isRequired: true,
                predefinedFieldType: PredefinedFieldType.bsn,
                dependsOn: dependsOnShowIfWmoOrBwOrWlz
              },
              staatClientInRegister: {
                isRequired: true,
                predefinedFieldType: PredefinedFieldType.radioYesNo,
                dependsOn: dependsOnShowIfWmoOrBwOrWlz
              },
              ibanClient: {
                isRequired: true,
                predefinedFieldType: PredefinedFieldType.iban,
                dependsOn: dependsOnShowIfWmoOrBwOrWlz
              },
              bijlageRekeningAfschrift: {
                isRequired: true,
                predefinedFieldType: PredefinedFieldType.bijlage,
                maxFileAmount: 1,
                dependsOn: dependsOnShowIfWmoOrBwOrWlz
              },
              klantid: {
                isRequired: true,
                predefinedFieldType: PredefinedFieldType.cakKenmerk,
                dependsOn: dependsOnShowIfBurgerregeling
              }
            }
          },
          {
            name: "stap_mijn_client__mijn_vraag",
            fields: {
              vraag: {
                predefinedFieldType: PredefinedFieldType.textArea,
                dependsOn: dependsOnShowIfWmoOrBwOrWlz
              },
              vraagBurgerregelingen: {
                predefinedFieldType: PredefinedFieldType.textArea,
                isRequired: true,
                dependsOn: dependsOnShowIfBurgerregeling
              },
              bijlage: {
                predefinedFieldType: PredefinedFieldType.bijlage,
                maxFileAmount: 3,
                dependsOn: dependsOnShowIfWmoOrBwOrWlz
              },
              bijlageBurgerregeling: {
                isRequired: false,
                predefinedFieldType: PredefinedFieldType.bijlage,
                dependsOn: dependsOnShowIfBurgerregeling
              }
            },
            dependsOn: dependsOnShowIfRegelingIsGiven
          }
        ]
      },
      {
        name: translate("MijnGegevens"),
        Sections: [
          {
            name: "stap_contactgegevens__contactgegevens",
            fields: {
              uBent: {
                validate: {
                  isRequired: { value: true }
                },
                type: "select",
                options: [
                  {
                    label: translate("UBentProfessional"),
                    value: "UBentProfessional"
                  },
                  {
                    label: translate("UBentFamilielidOnbekend"),
                    value: "UBentFamilielidOnbekend"
                  },
                  {
                    label: translate("UBentWsnp"),
                    value: "UBentWsnp"
                  }
                ],
                ui: {
                  flexDirection: "column"
                },
                dependsOn: dependsOnShowIfWmoOrBwOrWlz
              },
              naamKantoor: {
                predefinedFieldType: PredefinedFieldType.text
              },
              aanhef: {
                validate: {
                  isRequired: { value: true }
                },
                type: "radio",
                options: [
                  {
                    label: translate("DeHeer"),
                    value: "DeHeer"
                  },
                  {
                    label: translate("Mevrouw"),
                    value: "Mevrouw"
                  }
                ],
                ui: {
                  flexDirection: "column"
                }
              },
              voorlettersVertegenwoordiger: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true
              },
              achternaamVertegenwoordiger: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true,
                autoComplete: true
              },
              email: {
                predefinedFieldType: PredefinedFieldType.email,
                isRequired: true,
                autoComplete: true
              },
              telefoonnummer: {
                predefinedFieldType: PredefinedFieldType.telefoonnummer,
                isRequired: true,
                autoComplete: true
              }
            }
          },
          {
            name: "stap_contactgegevens__adresgegevens",
            fields: {
              ...GetAdresFieldSet(undefined, true)
            },
            dependsOn: dependsOnShowIfWmoOrBwOrWlz
          }
        ]
      }
    ]
  };
};
